
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

const TopBar: React.FC = () => {
  return (
    <div className="border-b border-border/40 bg-muted/30">
      <div className="container flex h-10 items-center justify-between px-4 md:px-6">
        <div className="flex items-center space-x-4 text-xs font-medium text-muted-foreground">
          <p className="transition-colors duration-200 hover:text-foreground">
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
        <div className="flex items-center space-x-6">
          <Link to="/faq" className={cn(
            "text-xs text-muted-foreground hover:text-foreground transition-colors relative",
            "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px",
            "after:origin-bottom-left after:scale-x-0 hover:after:scale-x-100",
            "after:bg-foreground after:transition-transform after:duration-300"
          )}>
            Support
          </Link>
          <Link to="/contact-us" className={cn(
            "text-xs text-muted-foreground hover:text-foreground transition-colors relative",
            "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px",
            "after:origin-bottom-left after:scale-x-0 hover:after:scale-x-100",
            "after:bg-foreground after:transition-transform after:duration-300"
          )}>
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
